// extracted by mini-css-extract-plugin
export default {"headerSection":"BackButton_headerSection__BiIz-","backButton":"BackButton_backButton__SI3qJ"};